import * as React from "react";
import { cn } from "../../lib/utils";

export interface EDSListProps extends React.HTMLAttributes<HTMLUListElement> {
  children: React.ReactNode;
  className?: string;
  maxHeight?: number;
  style?: React.CSSProperties;
}

const EDSList = React.forwardRef<HTMLUListElement, EDSListProps>(
  ({ children, className, maxHeight, style, ...props }, ref) => {
    const listStyle: React.CSSProperties = {
      maxHeight: maxHeight ? `${maxHeight}px` : undefined,
      overflowY: maxHeight ? "auto" : undefined,
      ...style
    };

    return (
      <ul
        ref={ref}
        className={cn(
          "eds-list",
          "space-y-1",
          "border border-border rounded-md",
          "bg-background",
          className
        )}
        style={listStyle}
        {...props}
      >
        {children}
      </ul>
    );
  }
);

EDSList.displayName = "EDSList";

export { EDSList };
